import React from "react"

import { Cell, CellText } from "../../styles/TableCell.styled"

const PackageTableText = ({ text }) => {
  return (
    <Cell>
      <CellText>{text}</CellText>
    </Cell>
  )
}

export default PackageTableText
